<template>
    <div v-if="internalErrorMessage" class="mb-3">
        <Message severity="error" :closable="false">
            <div v-html="internalErrorMessage"></div>
        </Message>
    </div>

    <div class="mt-3 mb-3 text-center header-area">
        <h3 class="text-center">{{ subscriptionDetails.header }}</h3>

        <Image v-if="subscriptionDetails.logo" class="img-thumbnail"
               :src="subscriptionDetails.logo" width="100" />
    </div>
    <div class="mb-3 text-center">{{ subscriptionDetails.description }}</div>
        <div class="field">
            <InputGroup>
                <InputGroupAddon>Your Email</InputGroupAddon>
                <InputText :readonly="readonlyGiver"
                          v-model="subscription.giver.email"
                          placeholder="Your email" dusk="giver-email"
                          :invalid="v$.subscription.giver.email.$invalid" />
            </InputGroup>
        </div>
        <div class="field">
            <InputGroup>
                <InputGroupAddon>Your Name</InputGroupAddon>
                <InputText :readonly="readonlyGiver"
                          v-model="subscription.giver.name"
                          placeholder="Name shown to recipient" dusk="giver-name"
                          :invalid="v$.subscription.giver.name.$invalid" />
            </InputGroup>
        </div>
        <div class="field">
            <InputGroup>
                <InputGroupAddon>Recipient Email</InputGroupAddon>
                <InputText :readonly="readonlyReceiver" dusk="recipient-email"
                              v-model="subscription.receiver.email"
                              :invalid="v$.subscription.receiver.email.$invalid" />
            </InputGroup>
        </div>
        <div class="field">
            <InputGroup>
                <InputGroupAddon>Recipient Name</InputGroupAddon>
                <InputText dusk="recipient-name"
                              v-model="subscription.receiver.name"
                              :invalid="v$.subscription.receiver.name.$invalid" />
            </InputGroup>
        </div>
        <div class="field">
            <InputGroup>
                <InputGroupAddon>Price</InputGroupAddon>
                <InputText v-model="subscriptionDetails.plan.name" readonly />
                <InputGroupAddon>{{ subscriptionDetails.plan.currency }}</InputGroupAddon>
            </InputGroup>
        </div>

        <div class="field">
            <InputGroup>
                <InputGroupAddon>Start Date</InputGroupAddon>
                <Calendar v-model="subscription.activateAt" dateFormat="mm/dd/yy"
                          :minDate="new Date()"
                          :invalid="v$.subscription.activateAt.$invalid"
                />
            </InputGroup>
        </div>
        <div class="field">
            <Textarea
                v-model="subscriptionDetails.customMessage"
                placeholder="Optional Message"
                rows="3"
                max-rows="6"
                fluid
            ></Textarea>
        </div>

        <div v-if="!subscriptionDetails.errorMessage">
            <div class="text-center">
                <Button v-if="!isBusy" @click="stripeCheckoutAction">CONTINUE</Button>
                <div v-if="isBusy">
                    <Button :loading="true" outlined>PLEASE WAIT</Button>
                </div>
            </div>
        </div>

        <div class="field" v-if="!subscriptionDetails.errorMessage">
            <Message severity="secondary" class="p-3" :closable="false" v-html="getDescriptionHtml" />
        </div>
</template>
<script>
import { mapActions } from 'vuex'
import { giftService } from "../../services";

import { loadStripe } from '@stripe/stripe-js';

import {useVuelidate} from '@vuelidate/core'
import {required, email} from '@vuelidate/validators'
import {getPriceFormattedData, redirectToStripeCheckout} from "../../helpers/global.js";

export default {
    setup() {
        return {
            v$: useVuelidate(),
        }
    },
    data () {
        return {
            isBusy: false,
            subscription: {
                giver: {
                    name: null,
                    email: null,
                    guid: null,
                },
                receiver: {
                    name: null,
                    email: null,
                    guid: null
                },
                activateAt: null,
            },
            sessionId: null,
            readonlyGiver: false,
            readonlyReceiver: false,
            internalErrorMessage: null,
            stripe: null,
        }
    },
    computed: {
        subscriptionDetails() {
            return window.subscriptionDetails;
        },
        getBasePlanData() {
            return window.subscriptionDetails.basePlan
        },
        getPlan() {
            const planData = this.getBasePlanData
            return planData && planData.plan ? planData.plan : null
        },
        getDescriptionHtml() {
            if (!this.getPlan) return null

            const {amount, currency, intervalText} = getPriceFormattedData(this.getPlan)

            return `
            <p><strong>Offer details</strong> ${intervalText} Subscription: ${amount} ${currency}.</p>
            `
        },
    },
    async mounted() {
        this.stripe = await loadStripe(window.subscriptionDetails.stripeApiKey);
    },
    created () {
        if (!this.subscriptionDetails) {
            this.alertError('Wrong subscription URL');
        } else {
            if (this.subscriptionDetails.receiver.guid) {
                this.readonlyReceiver = true
            }
            if (this.subscriptionDetails.giver.guid && this.subscriptionDetails.giver.name) {
                this.readonlyGiver = true
            }
            this.subscription.giver = window.subscriptionDetails.giver
            this.subscription.receiver = window.subscriptionDetails.receiver

            if (window.subscriptionDetails.activateAt) {
                this.subscription.activateAt = window.subscriptionDetails.activateAt
            } else {
                this.subscription.activateAt = new Date()
            }
        }
    },
    methods: {
        ...mapActions({
            'alertSuccess': 'alert/success',
            'alertError': 'alert/error',
        }),
        stripeCheckoutAction() {
            this.v$.subscription.$touch()
            if (this.v$.subscription.$invalid) {
                event.preventDefault()
                return
            }

            this.isBusy = true
            let params = this.subscriptionDetails;
            params.activateAt = this.subscription.activateAt;

            giftService.createSession(params).then(
                response => {
                    this.isBusy = false

                    if (response.message) {
                        this.alertSuccess(response.message)
                    } else {
                        if (response.errorMessage) {
                            this.internalErrorMessage = response.errorMessage
                        } else {
                            this.sessionId = response.sessionId
                            redirectToStripeCheckout(this.stripe, response.sessionId);
                        }
                    }
                },
                error => {
                    this.alertError(error)
                    this.isBusy = false
                }
            )
        },
    },
    validations: {
        subscription: {
            giver: {
                email: {
                    required,
                    email
                },
                name: {
                    required,
                },
            },
            receiver: {
                email: {
                    required,
                    email
                },
                name: {
                    required,
                },
            },
            activateAt: {
                required,
            }
        }
    }

}
</script>

